import { useEffect } from 'react';
import { initMetaPixel, trackCheckoutClicks, trackMetaEvent } from '../utils/metaPixel';
import { offer } from '../data/offer';

export function useMetaPixel(): void {
  useEffect(() => {
    initMetaPixel();
    const stopCheckoutTracking = trackCheckoutClicks();

    // ViewContent once the offer section is seen.
    const offerEl = document.getElementById('offer-details');
    let fired = false;
    const observer = offerEl
      ? new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && !fired) {
              fired = true;
              trackMetaEvent('ViewContent', {
                content_name: 'HYROX Mega Pack',
                value: offer.price ?? undefined,
                currency: offer.currency ?? undefined,
              });
              observer?.disconnect();
            }
          },
          { threshold: 0.3 },
        )
      : null;
    if (offerEl && observer) observer.observe(offerEl);

    return () => {
      stopCheckoutTracking();
      observer?.disconnect();
    };
  }, []);
}
